import { VK } from '@/define/define'
//功能键区ESC~F12
const fn_vk: VK[] = [0x1b, 0x70, 0x71, 0x72, 0x73, 0x74, 0x75, 0x76, 0x77, 0x78, 0x79, 0x7a, 0x7b]

// 数字键盘区
const num_vk: VK[][] = [
  [0x90, 0x6f, 0x6a, 0x6d],
  [0x67, 0x68, 0x69, 0x6b],
  [0x64, 0x65, 0x66],
  [0x61, 0x62, 0x63, 0xfd],
  [0x60, 0x6e],
]

// 主键盘区
const main_vk: VK[][] = [
  [0xc0, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x30, 0xbd, 0xbb, 0x8],
  [0x09, 0x51, 0x57, 0x45, 0x52, 0x54, 0x59, 0x55, 0x49, 0x4f, 0x50, 0xdb, 0xdd, 0xdc],
  [0x14, 0x41, 0x53, 0x44, 0x46, 0x47, 0x48, 0x4a, 0x4b, 0x4c, 0xba, 0xde, 0x0d],
  [0xa0, 0x5a, 0x58, 0x43, 0x56, 0x42, 0x4e, 0x4d, 0xbc, 0xbe, 0xbf, 0xa1],
]

// 空格行
const main_b_vk: VK[] = [0xa2, 0x5b, 0xa4, 0x20, 0xa5, 250, 0x5d, 0xa3]
const main_fe_vk: VK[] = [0xa2, 0x5b, 0xa4, 0x20, 0xa5, 250, 0xa3]
const main_li75_vk: VK[] = [0xa2, 0x5b, 0xa4, 0x20, 0xa5, 250, 0xa3]
const main_op_vk: VK[] = [0xa2, 0x5b, 0xa4, 0x20, 0xa5, 250]
const main_c_b_vk: VK[] = [0xa2, 0x5b, 0xa4, 0x20, 250, 0xa3]
const mgx_main_c_b_vk: VK[] = [0xa2, 0x5b, 0xa4, 0x20, 0xa5, 250]

// 箭头区
const arrow_vk: VK[][] = [[0x26], [0x25, 0x28, 0x27]]

// 控制区
const control_vk: VK[][] = [
  [0x2c, 0x91, 0x13],
  [0x2d, 0x24, 0x21],
  [0x2e, 0x23, 0x22],
]

/**********************--------------------------------------------------------------------***********************/

export const mouseVKCodes: VK[][] = [[0, 0x01, 0x02, 0x04, 0x05, 0x06]]
// 错误前进和后退（vk） 兼容he2鼠标
export const mouseVKCodes_c: VK[][] = [[0x01, 0x02, 0x04, 0x10, 0x08, 0]]

export const al87VKCodes: VK[][] = [[...fn_vk, ...control_vk[0]], [...main_vk[0], ...control_vk[1]], [...main_vk[1], ...control_vk[2]], [...main_vk[2]], [...main_vk[3], ...arrow_vk[0]], [...main_b_vk, ...arrow_vk[1]]]
export const fe75VKCodes: VK[][] = [
  [...fn_vk, 0x2d],
  [...main_vk[0], 0x2e],
  [...main_vk[1], 0x21],
  [...main_vk[2], 0x22],
  [...main_vk[3], ...arrow_vk[0]],
  [...main_fe_vk, ...arrow_vk[1]],
]
export const fe98VKCodes: VK[][] = [
  [...fn_vk, ...[0x2e, 0x2d, 0x21, 0x22]],
  [...main_vk[0], ...num_vk[0]],
  [...main_vk[1], ...num_vk[1]],
  [...main_vk[2], ...num_vk[2]],
  [...main_vk[3], ...arrow_vk[0], ...num_vk[3]],
  [...main_c_b_vk, ...arrow_vk[1], ...num_vk[4]],
]
export const li75VKCodes: VK[][] = [[...fn_vk], [...main_vk[0], 0x2e], [...main_vk[1], 0x23], [...main_vk[2], 0x21], [...main_vk[3], ...arrow_vk[0], 0x22], [...main_li75_vk, ...arrow_vk[1]]]
export const mu68VKCodes: VK[][] = [
  [0x1b, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x30, 0xbd, 0xbb, 0x8, 0x2d],
  [...main_vk[1], 0x2e],
  [...main_vk[2], 0x21],
  [...main_vk[3], ...arrow_vk[0], 0x22],
  [...mgx_main_c_b_vk, 0xa3, ...arrow_vk[1]],
]
export const nd63VKCodes: VK[][] = [[0x1b, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x30, 0xbd, 0xbb, 0x8], [...main_vk[1]], [...main_vk[2]], [...main_vk[3], ...arrow_vk[0], 0x6e], [...mgx_main_c_b_vk, ...arrow_vk[1]]]
export const nd63VKCodes_del: VK[][] = [[0x1b, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x30, 0xbd, 0xbb, 0x8], [...main_vk[1]], [...main_vk[2]], [...main_vk[3], ...arrow_vk[0], 0x6e, 0x2e], [...mgx_main_c_b_vk, ...arrow_vk[1]]]
export const na87VKCodes: VK[][] = [[...fn_vk, ...control_vk[0]], [...main_vk[0], ...control_vk[1]], [...main_vk[1], ...control_vk[2]], [...main_vk[2]], [...main_vk[3], ...arrow_vk[0]], [...mgx_main_c_b_vk, 0x5d, 0xa3, ...arrow_vk[1]]]
export const nd75VKCodes: VK[][] = [
  [...fn_vk, 0x2d],
  [...main_vk[0], 0x2e],
  [...main_vk[1], 0x21],
  [...main_vk[2], 0x22],
  [...main_vk[3], ...arrow_vk[0]],
  [...mgx_main_c_b_vk, 0xa3, ...arrow_vk[1]],
]

export const op75VKCodes: VK[][] = [
  [...fn_vk, control_vk[0][0]],
  [...main_vk[0], control_vk[2][0]],
  [...main_vk[1], control_vk[1][2]],
  [...main_vk[2], control_vk[2][2]],
  [...main_vk[3], ...arrow_vk[0]],
  [...main_op_vk, ...arrow_vk[1]],
]
export const tp87VKCodes: VK[][] = [[...fn_vk, ...control_vk[0]], [...main_vk[0], ...control_vk[1]], [...main_vk[1], ...control_vk[2]], [...main_vk[2]], [...main_vk[3], ...arrow_vk[0]], [...main_b_vk, ...arrow_vk[1]]]

export const polar75VKCodes: VK[][] = [
  [...fn_vk, control_vk[0][0], control_vk[2][0]],
  [...main_vk[0], control_vk[1][0]],
  [...main_vk[1], control_vk[1][2]],
  [...main_vk[2], control_vk[2][2]],
  [...main_vk[3], ...arrow_vk[0]],
  [...mgx_main_c_b_vk, ...arrow_vk[1]],
]
export const mer68VKCodes: VK[][] = [
  [0x1b, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x30, 0xbd, 0xbb, 0x8, 0x2d],
  [...main_vk[1], 0x2e],
  [...main_vk[2], 0x21],
  [...main_vk[3], ...arrow_vk[0], 0x22],
  [...mgx_main_c_b_vk, 0xa3, ...arrow_vk[1]],
]
